export default __webpack_public_path__ + "ce7f502b4cf10d06b8ace21db0b871cf.png";